'use client';
import { Table } from 'antd';
import { Entering, LoadingLogo, Pagination, Typography } from 'components';
import { EmptyInboxClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';

import { InfoHollowIcon } from 'lib/svgs/Icons';
import 'styles/sass/ant-design/ant-design-table-checkbox.scss';
import FilterSortOrders from './_components/FilterSortOrders';
import { useOrdersContext } from './_context/OrdersContext';
import { PurchaseOrderUnitary } from './_context/useTableOrders';

export default function OrdersPage() {
  const t = useTranslations();

  const {
    isLoading,
    isPending,
    page,
    setPage,
    totalPages,
    isRetrieving,
    columns,
    orders,
    ordersUnitary
  } = useOrdersContext();

  return (
    <div className="mt-6">
      <Entering offset={5} delay={0.6} duration={0.2} position="bottom" className="gap-10">
        <div className="mt-1">
          <Entering
            offset={5}
            delay={0.6}
            position="bottom"
            className="rounded-t-md bg-white shadow-custom"
          >
            <div className="flex justify-between !p-4 !px-6">
              <Typography
                variant="medium1"
                className="relative left-0 top-0 flex items-center text-tertiary-100"
              >
                <span className="flex gap-2">
                  {t('billing.orders.title')}
                  <span className="text-tertiary-200">({orders?.nodesCount})</span>
                </span>
                <a
                  data-tooltip-id="tolq-info-top-start"
                  data-tooltip-html={t('billing.orders.info')}
                >
                  <InfoHollowIcon className="scale-[0.5] cursor-pointer pb-1" />
                </a>
              </Typography>
              <span className="flex gap-4">
                <FilterSortOrders />
              </span>
            </div>
            {(isLoading || isPending) && (
              <div className="grid h-[50vh] flex-1 place-content-center">
                <div className="relative flex flex-col items-center justify-center">
                  <LoadingLogo size="x-small" className="absolute -left-8" />
                </div>
              </div>
            )}

            {!(isLoading || isPending) && !!ordersUnitary?.length && (
              <Table<PurchaseOrderUnitary>
                key={`${page}`}
                tableLayout="auto"
                columns={columns}
                dataSource={ordersUnitary || []}
                pagination={false}
                scroll={{
                  x: true
                }}
              />
            )}
            {!(isLoading || isPending) && (!ordersUnitary || ordersUnitary.length === 0) && (
              <div className="grid h-[50vh] flex-1 place-content-center">
                <div className="flex flex-col items-center justify-center">
                  <EmptyInboxClipArt />
                  <Typography
                    variant="light3"
                    className="flex max-w-[250px] text-center text-tertiary-200"
                  >
                    {t('billing.orders.empty')}
                  </Typography>
                </div>
              </div>
            )}
            {!!totalPages && !!page && !isRetrieving && (
              <Pagination
                totalPages={totalPages}
                changePage={setPage}
                page={page}
                className="flex justify-center pb-8 pt-6"
              />
            )}
          </Entering>
        </div>
        <div className="flex justify-center py-10" />
      </Entering>
    </div>
  );
}
